.backdrop {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition:
    opacity 50ms linear,
    visibility 0s linear 50ms;
}

.backdropOpen {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transition:
    opacity 50ms linear,
    visibility 0s linear 0s;
}

.navWrapper {
  pointer-events: none;
}

.navPanel {
  visibility: hidden;
  transform: translateX(-100%);
  transition:
    transform 100ms ease-in-out,
    visibility 0s linear 100ms;
}

.navPanelOpen {
  visibility: visible;
  transform: translateX(0);
  pointer-events: auto;
  transition:
    transform 100ms ease-in-out,
    visibility 0s linear 0s;
}

@screen desktop {
  .navPanel {
    transform: none;
    opacity: 0;
    visibility: hidden;
    transition:
      opacity 50ms linear,
      visibility 0s linear 50ms;
  }

  .navPanelOpen {
    transform: none;
    opacity: 1;
    visibility: visible;
    transition:
      opacity 50ms linear,
      visibility 0s linear 0s;
  }
}
